import { useEffect, useRef, useState } from "react";
import {
  getLeanPaymentsForBalance,
  getFiltersPaymentsByCustomer,
} from "../../database/helpers/payment";
import { NEW_SORT } from "../../constants";
import { handleApi } from "../../apis";
import { GET_SHARED_ACCOUNT_PAYMENT } from "../../apis/configuration";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import axios from "axios";

export const useCustomerTxns = (filters, type) => {
  const navigate = useNavigate();

  const [state, setState] = useState({
    isLoading: true,
    txnsList: [],
    allTxnslist: [],
    totalAmount: 0,
  });

  const cancelTokenSourceRef = useRef(null);
  const balanceCacheKeyRef = useRef(null);

  const invalidateBalanceCache = () => {
    balanceCacheKeyRef.current = null;
  };

  const cancelPreviousRequest = () => {
    if (cancelTokenSourceRef.current) {
      cancelTokenSourceRef.current.cancel(
        "Request canceled due to new request.",
      );
    }
    cancelTokenSourceRef.current = axios.CancelToken.source();
    return cancelTokenSourceRef.current;
  };

  const handleGetCustomerTxns = async ({
    customerId,
    startPage,
    endPage,
    offset,
  }) => {
    setState((prev) => ({ ...prev, isLoading: true }));
    try {
      if (type?.toLowerCase() == "community") {
        const cancelToken = cancelPreviousRequest();

        let sort = "";
        if (filters.sort == NEW_SORT.amountHighToLow) {
          sort = "amountHighToLow";
        } else if (filters.sort == NEW_SORT.amountLowToHigh) {
          sort = "amountLowToHigh";
        } else if (filters?.sort) {
          sort = filters?.sort?.toLowerCase();
        }

        const filterObj = {};

        // type
        if (filters?.type?.length) {
          filterObj.type = filters.type.map((type) => type?.toLowerCase());
        }

        // sort
        if (sort) {
          filterObj.sort = sort;
        }

        // date
        if (filters?.date?.startDate) {
          filterObj.date = {
            start: moment(filters.date.startDate, "DD MMM YYYY").format(
              "DD MMM YYYY",
            ),
            end: moment(filters.date.endDate, "DD MMM YYYY").format(
              "DD MMM YYYY",
            ),
          };
        }

        // amount
        if (filters?.amount?.min || filters?.amount?.max) {
          filterObj.amount = {
            min: Number(filters.amount.min),
          };

          if(filters?.amount?.max > 0) {
            filterObj.amount.max = Number(filters.amount.max)
          }

        }

        // prev_record
        
        let prev_record = {}; 
        if (state?.txnsList?.length && offset > 0) {
          prev_record = state.txnsList[state.txnsList.length - 1];
        }

        const params = {
          customer_id: customerId,
          filters: filterObj,
          keyword: filters?.keywords,
          offset: offset,
          prev_record : prev_record
        };

        const response = await handleApi(
          GET_SHARED_ACCOUNT_PAYMENT,
          params,
          cancelToken,
          navigate,
        );

        setState((prev) => ({
          ...prev,
          isLoading: false,
          txnsList:
            offset === 0
              ? response?.data
              : [...prev.txnsList, ...response?.data],
          totalAmount: response?.total_outstanding_balance,
          allItemsCount: response?.total_records,
        }));

        return;
      }

      const sort = filters?.sort ?? null;
      const cacheKey = `${customerId}__${sort}`;
      const needsBalanceFetch = balanceCacheKeyRef.current !== cacheKey;

      let items = await getFiltersPaymentsByCustomer(customerId || "", filters);
      const paginatedTxnsItems = items?.slice(startPage, endPage);

      if (needsBalanceFetch) {
        balanceCacheKeyRef.current = cacheKey;
        const allItemsLean = await getLeanPaymentsForBalance(customerId || "", sort);

        setState({
          isLoading: false,
          txnsList: paginatedTxnsItems,
          allTxnslist: allItemsLean,
          allItemsCount: items?.length || 0,
        });
      } else {
        setState((prev) => ({
          ...prev,
          isLoading: false,
          txnsList: paginatedTxnsItems,
          allItemsCount: items?.length || 0,
        }));
      }
    } catch (err) {
      if (!axios.isCancel(err)) {
        setState((prev) => ({ ...prev, isLoading: false }));
      }
    }
  };

  useEffect(() => {
    return () => {
      cancelPreviousRequest();
    };
  }, []);

  return { ...state, handleGetCustomerTxns, invalidateBalanceCache };
};
